import { observer } from 'mobx-react-lite';
import { EventQueueRowData, UnitQueueRowData } from '../../../socket/stream-types';
import { MinutesCell } from '../../../queues/components/cells/common/minutes-cell';
import { getEventQueueRowData } from '../../../queues/utils/get-event-queue-row-data';

export const WorkingMinutesCell = observer(function WorkingMinutesCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    return <MinutesCell date={getEventQueueRowData(data)?.timeDispatched} />;
});
